<template>
  <BasicAlert
    v-if="estWarningTotalVisible"
    alertLabel="Le coût global de la formation dépasse 100.000 €. N'hésitez pas à vérifier et apporter des corrections si nécessaire."
    alertType="warning"
  ></BasicAlert>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore.ts'
  import { isNumber } from '@/features/shared/tools'

  const store = useDemandeAFStore()
  const { model } = storeToRefs(store)

  const estWarningTotalVisible = computed(() => totalFormation.value > 100_000)

  const totalFormation = computed(() => {
    const fraisModules = model.value?.formation?.modules?.flatMap((module) => module.fraisPedagogiques ?? []) ?? []
    const fraisAnnexes = model.value?.fraisAnnexes?.flatMap(fa => fa.frais ?? []) ?? []

    return [
      ...fraisModules,
      ...fraisAnnexes
    ].map(frais => ({
        quantite: isNumber(frais.quantite) && frais.quantite ? frais.quantite : 1,
        montant: frais.montant ?? 0,
      })
    ).map(frais =>
      frais.quantite * frais.montant
    ).reduce((acc, montant) => acc + montant, 0)
  })
</script>


<style scoped lang="less"></style>

